/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from './dayjs';
import webUrlRegexp from './webUrlRegexp';
import TimeoutTimer from './timeoutTimer';
export const getTranslation = (hash, key) => {
    if (!hash || !key || Object.keys(hash).length === 0)
        return '';
    // @ts-ignore
    return hash[key] || Object.values(hash).find(v => v.length > 0) || '';
};
export { dayjs, webUrlRegexp, TimeoutTimer };
export { default as useIsMobile } from './useIsMobile';
export { default as supportsPassive } from './supportsPassive';
//# sourceMappingURL=index.js.map